import React from 'react';
import {Item} from '../../../../../../../types/app.types';
import {classes, st} from './Modifiers.st.css';
import {useLocaleKeys} from '../../../../../LocaleKeysProvider';
import {processModifierGroups} from './processModifierGroups';
import {getTranslatedString} from './getTranslatedString';
import {ModifierDetails} from './ModifierDetails';
import {useControllerProps} from '../../../../ControllerContext';

const MAX_LINES = 5;

export const ModifiersDataHook = Object.freeze({
  Root: 'ModifiersDataHook.Modifiers',
  GroupHeader: 'ModifiersDataHook.Modifiers.GroupHeader',
  ModifierLine: 'ModifiersDataHook.Modifiers.ModifierLine',
  HiddenContent: 'ModifiersDataHook.Modifiers.HiddenContent',
});

export function Modifiers({modifierGroups}: {modifierGroups: Item['modifierGroups']}) {
  const {shouldEnableModifiers} = useControllerProps().thankYouPageStore;

  const {visibleContent, hiddenContent} = processModifierGroups(modifierGroups, {
    maxLines: MAX_LINES,
    renderModifierGroup: (group) => <ModifierGroup group={group} />,
    renderModifierDetails: (modifier) => <ModifierDetails modifier={modifier} />,
  });

  if (!shouldEnableModifiers || !modifierGroups?.length) {
    return null;
  }

  return (
    <ul className={st(classes.root)} data-hook={ModifiersDataHook.Root}>
      {visibleContent}
      <HiddenContent count={hiddenContent.length} />
    </ul>
  );
}

Modifiers.displayName = 'ProductLineItem.Modifiers';

function ModifierGroup({group}: {group: NonNullable<NonNullable<Item['modifierGroups']>[number]>}) {
  const lk = useLocaleKeys();
  return (
    <li className={st(classes.groupHeader)} data-hook={ModifiersDataHook.GroupHeader}>
      {lk.thankYouPage.modifiers.categoryLabel({categoryName: getTranslatedString(group.name)})}
    </li>
  );
}

function HiddenContent({count}: {count: number}) {
  const lk = useLocaleKeys();

  if (count === 0) {
    return null;
  }

  return <li data-hook={ModifiersDataHook.HiddenContent}>{lk.thankYouPage.modifiers.moreHidden({count})}</li>;
}
